module.exports = __webpack_public_path__ + "img/3.2c329e34.jpg";